import { Component, OnInit, Inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
@Component({
	selector: 'app-add-subtract-fund-popup',
	templateUrl: './add-subtract-fund-popup.component.html',
	styleUrls: ['./add-subtract-fund-popup.component.scss'],
})
export class AddSubtractFundPopupComponent implements OnInit {
	formData: FormGroup = new FormGroup({})
	constructor(
		public dialog: MatDialogRef<AddSubtractFundPopupComponent>,
		public translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.formData = new FormGroup({
			amount: new FormControl('', [
				Validators.required,
				Validators.min(1),

				data?.type == 'sub'
					? Validators.max(data?.currentAmount)
					: Validators.pattern(/^[0-9]{1,6}(\.[0-9]{1,2})?$/),
			]),
			reason: new FormControl('', [Validators.required]),
			showReasonToClient: new FormControl(false),
		})
	}

	ngOnInit(): void {}
	getController(controlName: string) {
		return this.formData.controls[controlName] as FormControl
	}
	confirm() {
		this.dialog.close({ ...this.formData.getRawValue() })
	}

	closeDialog() {
		this.dialog.close()
	}
}
